@app.service 'navService', ($rootScope) ->

  # Nav States:
  # nav-ghost
  # nav-sticky
  # nav-joule

  @previousState
  @navState = ''

  @setState = (navState) =>
    @navState = navState
    $rootScope.$emit 'nav.stateChange'

  @setPreviousState = =>
    @previousState = @navState

  @usePreviousState = =>
    @navState = @previousState

  @getState = =>
    @navState

  @showCollectionNavPrompt = true

  this
